import { useState } from 'react';
import { ColumnDetailsMap } from '../models/ColumnDetailsMap';
import { ColumnDetails } from '../models/ColumnDetails';
import { ColumnLabel } from '../models/ColumnLabel';

type UseTableSettingsProps = {
  bestPracticesColumnOrder: string[];
  columnsDetailsDescriptor: ColumnDetailsMap;
  columnLabels: ColumnLabel;
  disabledColumns: string[];
};

export const useTableSettings = ({ bestPracticesColumnOrder, columnsDetailsDescriptor }: UseTableSettingsProps) => {
  const [showTableSettingsDialog, setShowTableSettingsDialog] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [columnsDetails, setColumnsDetails] = useState<ColumnDetailsMap>(columnsDetailsDescriptor);
  const [columnOrder, setColumnOrder] = useState<string[]>(bestPracticesColumnOrder);

  const handleToggleTableSettingsDialog = () => setShowTableSettingsDialog(prev => !prev);

  const handleColumnChange = (
    newColumnOrder: string[],
    newHiddenColumns: string[],
    newColumnsDetails = columnsDetails
  ) => {
    setColumnOrder(newColumnOrder);
    setHiddenColumns(newHiddenColumns);
    setColumnsDetails(newColumnsDetails);
  };

  const handleColumnDetailsChange = (column: string, newColumnDetails: ColumnDetails) => {
    setColumnsDetails(prev => ({
      ...prev,
      [column]: newColumnDetails,
    }));
  };

  return {
    showTableSettingsDialog,
    setShowTableSettingsDialog,
    hiddenColumns,
    setHiddenColumns,
    columnsDetails,
    setColumnsDetails,
    columnOrder,
    setColumnOrder,
    handleToggleTableSettingsDialog,
    handleColumnChange,
    handleColumnDetailsChange,
  };
};